import React, { useEffect, useRef } from "react";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { updatedDetail } from "../../../store/actions/precog";

const CurrencyList = ({activeCurrency, onChangeCurrency, newDetail, setVisible}) => {
  const dispatch = useDispatch();
  const jsonCurrency = useSelector(state => state?.currencyList?.currencies);

  const currencyListRef = useRef();

  useEffect(() => {
    if (!currencyListRef.current) return undefined;
    let ps = new Scrollbar(currencyListRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [currencyListRef?.current]);

  const arrayCurrency = [];

  if (!jsonCurrency) return null;
  
  for (const [key, value] of Object.entries(jsonCurrency)) {
    if (activeCurrency){
      let activeClass = activeCurrency === key ? "active" : null;
      arrayCurrency.push(<div className={`currencyOption ${activeClass}`}
        onClick={() => {
          dispatch(updatedDetail(newDetail?.id,
            {
              refCurrency: key
            })).then(res => {
            onChangeCurrency(({...newDetail, refCurrency: key}));
            setVisible(false);
            // rilasciamo la pagina intera libera di scorrere
            document.body.style.overflow = "auto";
          // setLastUpdate(moment());
          }).catch(err => console.log(err));

        }
        } >{value.name}
        {activeClass && <FontAwesomeIcon
          icon={["far", "check-circle"]}
          style={{
            color: "#0090d1",
            margin: "0 10px"
          }}
        />}</div>);
    }
  }

  return <div className="popoverOverflow" ref={currencyListRef}>{arrayCurrency}</div>;

};

export default CurrencyList;